export { PricingSection as PricingFaqCombo } from "../core-business-sections"
export type { PricingSectionProps as PricingFaqComboProps } from "../core-business-sections"